<template>
	<div>
		<v-card-text class="py-0">
			<v-btn size="36" variant="text" icon @click="toggleExpansion" class="ml-0">
				<v-icon> mdi-play {{ expansion ? "mdi-rotate-90" : "" }} </v-icon>
			</v-btn>
			<span>{{ $t("DESIGN") }}</span>
		</v-card-text>
		<v-expand-transition>
			<div v-show="expansion" class="list mx-3 mb-3" id="design_list">
				<v-card-text v-if="mergedList.length === 0" class="pa-0 pl-10">
					{{ $t("NO_DATA") }}
				</v-card-text>
				<draggable handle=".handle" animation="553" v-model="mergedListDraggable" :item-key="itemKey">
					<template #item="{ element }">
						<v-card-text class="pa-0 handle">
							<design-list-item v-if="element.getType() == 'design'" :entity="element"
								:draggable="true"></design-list-item>
							<line-list-item-in-design v-else-if="element.getType() == 'lineworks'" :entity="element"
								:draggable="true"></line-list-item-in-design>
							<line-works-list-item v-else-if="element.getType() == 'simaLine'" :entity="element"
								:draggable="true"></line-works-list-item>
						</v-card-text>
					</template>
				</draggable>
			</div>
		</v-expand-transition>
	</div>
</template>

<script>
import draggable from "vuedraggable";
import { mapMutations, mapState } from "vuex";
import DesignListItem from "./DesignListItem.vue";
import LineListItemInDesign from "./LineWorks/LineListItemInDesign.vue";
import LineWorksListItem from "./LineWorks/LineWorksListItem.vue";
import { compareDateByType, toSessionOrderEntryKey } from "./listOrdering";
export default {
	components: {
		draggable,
		DesignListItem,
		LineListItemInDesign,
		LineWorksListItem,
	},
	name: "DesignList",
	data() {
		return {
			expansion: false,
			orderedKeys: [],
		};
	},
	computed: {
		...mapState(["design_list"]),
		...mapState("simaLine", ["simaLineList"]),
		sourceItems() {
			return [...this.design_list, ...this.simaLineList];
		},
		mergedList() {
			const defaultSorted = [...this.sourceItems].sort(compareDateByType);

			if (this.orderedKeys.length === 0) {
				return defaultSorted;
			}

			const itemsByKey = new Map(
				defaultSorted.map((item) => [this.itemKey(item), item]),
			);
			const orderedKnown = this.orderedKeys
				.map((key) => itemsByKey.get(key))
				.filter((item) => item !== undefined);
			const knownKeys = new Set(orderedKnown.map((item) => this.itemKey(item)));
			const unknownTail = defaultSorted.filter(
				(item) => !knownKeys.has(this.itemKey(item)),
			);

			return [...orderedKnown, ...unknownTail];
		},
		mergedListDraggable: {
			get() {
				return this.mergedList;
			},
			set(value) {
				const designItems = value.filter(
					(item) =>
						item.getType() === "design" || item.getType() === "lineworks",
				);
				const simaItems = value.filter((item) => item.getType() === "simaLine");
				this.orderedKeys = value.map((item) => this.itemKey(item));
				this.set_design_list(designItems);
				this.$store.commit("simaLine/setSimaLineList", simaItems);
			},
		},
	},
	methods: {
		...mapMutations(["set_design_list"]),
		itemKey(item) {
			return toSessionOrderEntryKey(item);
		},
		toggleExpansion() {
			this.expansion = !this.expansion;
		},
	},
};
</script>

<style lang="scss" scoped>
.list {
	max-height: 150px;
	overflow-y: auto;
	overflow-x: hidden;
	scroll-behavior: smooth;
}
</style>
